import axiosIns from '@/api/axios';

export const GET_LDP = (params) => {
  return axiosIns.get('/master-data/ldp', { params });
};

export const GET_LDP_BY_ID = (id) => {
  return axiosIns.get(`/master-data/ldp/${id}`);
};

export const CREATE_LDP = (data) => {
  return axiosIns.post('/master-data/ldp', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const UPDATE_LDP = (id, data) => {
  return axiosIns.put(`/master-data/ldp/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const DELETE_LDP = (id) => {
  return axiosIns.delete(`/master-data/ldp/${id}`);
};
